export default __webpack_public_path__ + "media/images/footer/googlesafe-f0401a14f74eb650dd90b11b277930ed.svg";